import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createLegalCheckForm(): FormGroup<ElektronikLegalCheckFormModel> {
  return new FormGroup<ElektronikLegalCheckFormModel>({
    hasAgreedToElectronicCommunication: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedPrivacyPolicy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedGeneralTermsAndConditions: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasReadInsuranceProductInformationSheet: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAuthorizedSepaDirectDebit: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcknowledgedRightOfWithdrawal: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasConfirmedProductMeetsWishesAndNeeds: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    })
  });
}

export interface ElektronikLegalCheckFormModel {
  hasAgreedToElectronicCommunication: FormControl<boolean>;
  hasAcceptedPrivacyPolicy: FormControl<boolean>;
  hasAcceptedGeneralTermsAndConditions: FormControl<boolean>;
  hasReadInsuranceProductInformationSheet: FormControl<boolean>;
  hasAuthorizedSepaDirectDebit: FormControl<boolean>;
  hasAcknowledgedRightOfWithdrawal: FormControl<boolean>;
  hasConfirmedProductMeetsWishesAndNeeds: FormControl<boolean>;
}
